import { render, staticRenderFns } from "./drivers.vue?vue&type=template&id=08cbd4c8&scoped=true&"
import script from "./drivers.vue?vue&type=script&lang=js&"
export * from "./drivers.vue?vue&type=script&lang=js&"
import style0 from "./drivers.vue?vue&type=style&index=0&id=08cbd4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbd4c8",
  null
  
)

export default component.exports